<template>
  <div 
    v-if="getEnableHoodq"
    :style="{'marginTop': getEnableWalkScore ? '80px' : '0'}"
  >
    <slot />
    <div class="hmt-hoodq-iframe">
      <iframe
        :src="getHoodqUrl"
        allowfullscreen
      >
      </iframe>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'HMTHoodQ',
    computed: {
      ...mapGetters('tour', ['getHoodqUrl', 'getEnableHoodq', 'getEnableWalkScore'])
    },
  }
</script>

<style lang="scss">
  .hmt-hoodq-iframe {
    width: 100%;
    height: 600px;

    iframe {
      border: none;
      width: 100%;
      height: 100%;
    }
  }
</style>
